import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getLanguage } from 'src/hooks/use-language-manager';
//
import translationEn from './langs/en.json';
import translationAr from './langs/ar.json';

// ----------------------------------------------------------------------

// Get initial language from centralized language manager
const initialLanguage = getLanguage();

// Simplified i18n configuration - only handles translations
i18n.use(initReactI18next).init({
  resources: {
    en: { translations: translationEn },
    ar: { translations: translationAr },
  },
  lng: initialLanguage,
  fallbackLng: 'ar',
  debug: false,
  ns: ['translations'],
  defaultNS: 'translations',
  interpolation: {
    escapeValue: false,
  },
  supportedLngs: ['en', 'ar'],
  load: 'languageOnly',
  // Remove localStorage management - handled by language manager
});

// Listen for language changes from the centralized manager
window.addEventListener('languageChanged', (event: any) => {
  const newLanguage = event.detail.language;
  if (i18n.language !== newLanguage) {
    i18n.changeLanguage(newLanguage);
  }
});

export default i18n;
